import IconDiv from './IconDiv';
import faTimes from '../img/icons/times.svg';

const TopBarModal = ({ closeModal, path }) => {
  return (
    <div className="menu-widget__top-bar-modal">
      <div className="menu-widget__top-bar-modal__title">Wybierz dietę</div>
      <div
        className="menu-widget__top-bar-modal__close"
        onClick={closeModal}
        onKeyPress={closeModal}
        role="button"
        tabIndex="0"
      >
        <IconDiv
          classes={'menu-widget__top-bar-modal__close-icon'}
          url={faTimes}
          path={path}
        />
      </div>
    </div>
  );
};

export default TopBarModal;
